// import React, { useState } from "react";
// import {
//     TextField,
//     Button,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     Paper,
//     Stack,
//     Grid,
//     Card,
//     CardContent,
//     IconButton,
//     Typography,
// } from "@mui/material";
// import { Close } from "@mui/icons-material";
// import { toast } from "react-toastify";

// const VariantTabContent = ({
//     productData,
//     setProductData,
//     size,
//     onNext,
//     onBack
// }) => {

//     const [variant, setVariant] = useState({
//         sizeId: "",
//         price: "",
//         stockQuantity: "",
//         vendorDiscountPercentage: "",
//         marginPrice: "",
//         adminDiscountPercentage: "",
//     });

//     // ================= CHANGE HANDLER =================
//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         if (
//             [
//                 "price",
//                 "stockQuantity",
//                 "vendorDiscountPercentage",
//                 "marginPrice",
//                 "adminDiscountPercentage",
//             ].includes(name)
//         ) {
//             if (!/^\d*$/.test(value)) return;
//         }

//         setVariant((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     // ================= ADD VARIANT =================
//     const handleAddVariant = () => {

//         if (!variant.sizeId || !variant.price || !variant.stockQuantity) {
//             toast.error("Please fill required fields");
//             return;
//         }

//         if (Number(variant.price) < 49) {
//             toast.error("Price must be greater than 49");
//             return;
//         }

//         const exists = productData.variants.find(
//             (v) => v.sizeId === variant.sizeId
//         );

//         if (exists) {
//             toast.error("Variant for this size already exists");
//             return;
//         }

//         const newVariant = {
//             id: null,                 // DB id (only for existing)
//             tempId: Date.now(),       // frontend tracking id
//             sizeId: variant.sizeId,
//             price: variant.price,
//             stockQuantity: variant.stockQuantity,
//             vendorDiscountPercentage: variant.vendorDiscountPercentage,
//             marginPrice: variant.marginPrice,
//             adminDiscountPercentage: variant.adminDiscountPercentage,
//         };

//         setProductData((prev) => ({
//             ...prev,
//             variants: [...prev.variants, newVariant],
//         }));

//         setVariant({
//             sizeId: "",
//             price: "",
//             stockQuantity: "",
//             vendorDiscountPercentage: "",
//             marginPrice: "",
//             adminDiscountPercentage: "",
//         });
//     };

//     // ================= REMOVE VARIANT =================
//     const handleRemove = (item) => {

//         setProductData((prev) => ({
//             ...prev,
//             variants: prev.variants.filter((v) => {

//                 // Existing DB variant
//                 if (v.id) {
//                     return v.id !== item.id;
//                 }

//                 // New frontend variant
//                 return v.tempId !== item.tempId;
//             }),
//         }));
//     };

//     // ================= SAVE =================
//     const handleSaveAndNext = () => {
//         if (productData.variants.length === 0) {
//             toast.error("Please add at least one variant");
//             return;
//         }

//         console.log("Final variant data:", productData.variants);
//         onNext();
//     };

//     return (
//         <Paper
//             elevation={0}
//             sx={{
//                 p: { xs: 2, md: 4 },
//                 borderRadius: 3,
//                 backgroundColor: "#fafafa",
//                 border: "1px solid #eee"
//             }}
//         >
//             <Grid container spacing={3}>

//                 {/* Size */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Size</InputLabel>
//                         <Select
//                             name="sizeId"
//                             value={variant.sizeId}
//                             label="Size"
//                             onChange={handleChange}
//                         >
//                             {size?.sizes?.response?.map((item) => (
//                                 <MenuItem key={item.id} value={item.id}>
//                                     {item.name}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 {/* Price */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Price"
//                         name="price"
//                         size="small"
//                         value={variant.price}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>

//                 {/* Stock */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Stock Quantity"
//                         name="stockQuantity"
//                         size="small"
//                         value={variant.stockQuantity}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>

//                 {/* Vendor Discount */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Vendor Discount (%)"
//                         name="vendorDiscountPercentage"
//                         size="small"
//                         value={variant.vendorDiscountPercentage}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>

//                 {/* Margin Price */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Margin Price"
//                         name="marginPrice"
//                         size="small"
//                         value={variant.marginPrice}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>

//                 {/* Admin Discount */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Admin Discount (%)"
//                         name="adminDiscountPercentage"
//                         size="small"
//                         value={variant.adminDiscountPercentage}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>

//                 {/* Add Button */}
//                 <Grid item xs={12} display="flex" justifyContent="center">
//                     <Button
//                         variant="contained"
//                         onClick={handleAddVariant}
//                         sx={{ borderRadius: 2, textTransform: "none" }}
//                     >
//                         Add
//                     </Button>
//                 </Grid>

//             </Grid>

//             {/* ================= VARIANT CARDS ================= */}
//             <Grid container spacing={2} mt={4}>
//                 {productData.variants.map((v) => (
//                     <Grid
//                         item
//                         xs={12}
//                         sm={6}
//                         md={4}
//                         key={v.id ?? v.tempId}   // FIXED KEY
//                     >
//                         <Card
//                             sx={{
//                                 borderRadius: 3,
//                                 boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//                                 position: "relative"
//                             }}
//                         >
//                             <CardContent>

//                                 <Typography fontWeight={600} mb={1}>
//                                     Size: {
//                                         size?.sizes?.response?.find(
//                                             s => s.id === v.sizeId
//                                         )?.name
//                                     }
//                                 </Typography>

//                                 <Typography variant="body2">
//                                     Price : ₹ {v.price}
//                                 </Typography>

//                                 <Typography variant="body2">
//                                     Stock: {v.stockQuantity}
//                                 </Typography>

//                                 {v.vendorDiscountPercentage && (
//                                     <Typography variant="body2">
//                                         Vendor Discount: {v.vendorDiscountPercentage}%
//                                     </Typography>
//                                 )}

//                                 {v.marginPrice && (
//                                     <Typography variant="body2">
//                                         Margin: ₹{v.marginPrice}
//                                     </Typography>
//                                 )}

//                                 {v.adminDiscountPercentage && (
//                                     <Typography variant="body2">
//                                         Admin Discount: {v.adminDiscountPercentage}%
//                                     </Typography>
//                                 )}
//                             </CardContent>

//                             <IconButton
//                                 size="small"
//                                 sx={{ position: "absolute", top: 6, right: 6 }}
//                                 onClick={() => handleRemove(v)}   // FIXED
//                             >
//                                 <Close fontSize="small" />
//                             </IconButton>

//                         </Card>
//                     </Grid>
//                 ))}
//             </Grid>

//             {/* ================= BOTTOM BUTTONS ================= */}
//             <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 spacing={2}
//                 justifyContent="flex-end"
//                 mt={5}
//             >
//                 <Button
//                     variant="outlined"
//                     onClick={onBack}
//                     sx={{ borderRadius: 2, textTransform: "none" }}
//                 >
//                     Back
//                 </Button>

//                 <Button
//                     variant="contained"
//                     onClick={handleSaveAndNext}
//                     sx={{ borderRadius: 2, textTransform: "none" }}
//                 >
//                     Save & Continue
//                 </Button>
//             </Stack>
//         </Paper>
//     );
// };

// export default VariantTabContent;

// import React, { useState } from "react";
// import {
//     TextField,
//     Button,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     Paper,
//     Stack,
//     Grid,
//     Card,
//     CardContent,
//     IconButton,
//     Typography,
// } from "@mui/material";
// import { Close } from "@mui/icons-material";
// import { toast } from "react-toastify";

// const VariantTabContent = ({
//     productData,
//     setProductData,
//     size,
//     onNext,
//     onBack
// }) => {

//     const [variant, setVariant] = useState({
//         sizeId: "",
//         price: "",
//         stockQuantity: "",
//         vendorDiscountPercentage: "",
//         marginPrice: "",
//         adminDiscountPercentage: "",
//     });

//     // ================= CHANGE =================
//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         const numberFields = [
//             "price",
//             "stockQuantity",
//             "vendorDiscountPercentage",
//             "marginPrice",
//             "adminDiscountPercentage",
//         ];

//         if (numberFields.includes(name) && !/^\d*$/.test(value)) return;

//         setVariant((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     // ================= ADD =================
//     const handleAddVariant = () => {

//         if (!variant.sizeId || !variant.price || !variant.stockQuantity) {
//             toast.error("Please fill required fields");
//             return;
//         }

//         if (Number(variant.price) < 49) {
//             toast.error("Price must be greater than 49");
//             return;
//         }

//         const exists = productData.variants?.some(
//             (v) => v.sizeId === variant.sizeId
//         );

//         if (exists) {
//             toast.error("Variant for this size already exists");
//             return;
//         }

//         const newVariant = {
//             id: null,                         // DB id
//             tempId: crypto.randomUUID(),      // frontend id
//             sizeId: variant.sizeId,
//             price: Number(variant.price),
//             stockQuantity: Number(variant.stockQuantity),
//             vendorDiscountPercentage: Number(variant.vendorDiscountPercentage || 0),
//             marginPrice: Number(variant.marginPrice || 0),
//             adminDiscountPercentage: Number(variant.adminDiscountPercentage || 0),
//         };

//         setProductData((prev) => ({
//             ...prev,
//             variants: [...(prev.variants || []), newVariant],
//         }));

//         setVariant({
//             sizeId: "",
//             price: "",
//             stockQuantity: "",
//             vendorDiscountPercentage: "",
//             marginPrice: "",
//             adminDiscountPercentage: "",
//         });
//     };

//     // ================= REMOVE =================
//     const handleRemove = (item) => {

//         setProductData((prev) => {

//             const filtered = prev.variants.filter((v) => {

//                 // DB variant
//                 if (item.id) {
//                     return v.id !== item.id;
//                 }

//                 // New variant
//                 return v.tempId !== item.tempId;
//             });

//             return {
//                 ...prev,
//                 variants: filtered
//             };
//         });
//     };

//     // ================= SAVE =================
//     const handleSaveAndNext = () => {

//         if (!productData.variants || productData.variants.length === 0) {
//             toast.error("Please add at least one variant");
//             return;
//         }
//         console.log("variants tab data :", productData)
//         onNext();
//     };

//     return (
//         <Paper sx={{ p: 4, borderRadius: 3 }}>

//             <Grid container spacing={3}>

//                 <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Size</InputLabel>
//                         <Select
//                             name="sizeId"
//                             value={variant.sizeId}
//                             label="Size"
//                             onChange={handleChange}
//                         >
//                             {size?.sizes?.response?.map((item) => (
//                                 <MenuItem key={item.id} value={item.id}>
//                                     {item.name}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Price"
//                         name="price"
//                         size="small"
//                         value={variant.price}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Stock Quantity"
//                         name="stockQuantity"
//                         size="small"
//                         value={variant.stockQuantity}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>
//                 {/* Vendor Discount */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Vendor Discount (%)"
//                         name="vendorDiscountPercentage"
//                         size="small"
//                         value={variant.vendorDiscountPercentage}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>

//                 {/* Margin Price */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Margin Price"
//                         name="marginPrice"
//                         size="small"
//                         value={variant.marginPrice}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>

//                 {/* Admin Discount */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         label="Admin Discount (%)"
//                         name="adminDiscountPercentage"
//                         size="small"
//                         value={variant.adminDiscountPercentage}
//                         onChange={handleChange}
//                         fullWidth
//                     />
//                 </Grid>

//                 <Grid item xs={12} display="flex" justifyContent="center">
//                     <Button
//                         variant="contained"
//                         onClick={handleAddVariant}
//                         sx={{ borderRadius: 2 }}
//                     >
//                         Add Variant
//                     </Button>
//                 </Grid>
//             </Grid>

//             {/* ===== Variant List ===== */}
//             <Grid container spacing={2} mt={4}>
//                 {(productData.variants || []).map((v) => (
//                     <Grid
//                         item
//                         xs={12}
//                         sm={6}
//                         md={4}
//                         key={v.id ? `db-${v.id}` : `temp-${v.tempId}`}
//                     >
//                         <Card sx={{ position: "relative", borderRadius: 3 }}>
//                             <CardContent>

//                                 <Typography fontWeight={600}>
//                                     Size: {
//                                         size?.sizes?.response?.find(
//                                             s => s.id === v.sizeId
//                                         )?.name
//                                     }
//                                 </Typography>

//                                 <Typography variant="body2">Price: ₹ {v.price}</Typography>
//                                 <Typography variant="body2">Stock: {v.stockQuantity}</Typography>

//                                 {v.vendorDiscountPercentage && (
//                                     <Typography variant="body2">
//                                         Vendor Discount: {v.vendorDiscountPercentage}%
//                                     </Typography>
//                                 )}

//                                 {v.marginPrice && (
//                                     <Typography variant="body2">
//                                         Margin: ₹{v.marginPrice}
//                                     </Typography>
//                                 )}

//                                 {v.adminDiscountPercentage && (
//                                     <Typography variant="body2">
//                                         Admin Discount: {v.adminDiscountPercentage}%
//                                     </Typography>
//                                 )}

//                             </CardContent>

//                             <IconButton
//                                 size="small"
//                                 sx={{ position: "absolute", top: 6, right: 6 }}
//                                 onClick={() => handleRemove(v)}
//                             >
//                                 <Close fontSize="small" />
//                             </IconButton>

//                         </Card>
//                     </Grid>
//                 ))}
//             </Grid>

//             <Stack direction="row" justifyContent="flex-end" spacing={2} mt={4}>
//                 <Button variant="outlined" onClick={onBack}>
//                     Back
//                 </Button>

//                 <Button variant="contained" onClick={handleSaveAndNext}>
//                     Save & Continue
//                 </Button>
//             </Stack>

//         </Paper>
//     );
// };

// export default VariantTabContent;

import React, { useState } from "react";
import {
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Paper,
    Stack,
    Grid,
    Card,
    CardContent,
    IconButton,
    Typography,
} from "@mui/material";
import { Close, Edit } from "@mui/icons-material";
import { toast } from "react-toastify";

const VariantTabContent = ({
    productData,
    setProductData,
    size,
    showFields,
    onNext,
    onBack
}) => {

    const emptyVariant = {
        id: null,
        tempId: null,
        sizeId: "",
        price: "",
        stockQuantity: "",
        vendorDiscountPercentage: "",
        marginPrice: "",
        adminDiscountPercentage: "",
    };

    const [variant, setVariant] = useState(emptyVariant);
    const [isEditing, setIsEditing] = useState(false);

    // ================= CHANGE =================
    const handleChange = (e) => {
        const { name, value } = e.target;

        const numberFields = [
            "price",
            "stockQuantity",
            "vendorDiscountPercentage",
            "marginPrice",
            "adminDiscountPercentage",
        ];

        if (numberFields.includes(name) && !/^\d*$/.test(value)) return;

        setVariant((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ================= ADD OR UPDATE =================
    const handleSaveVariant = () => {

        if (!variant.sizeId || !variant.price || !variant.stockQuantity) {
            toast.error("Please fill required fields");
            return;
        }

        if (Number(variant.price) < 49) {
            toast.error("Price must be greater than 49");
            return;
        }
        if (!isEditing) {
            const exists = productData.variants?.some(
                (v) => v.sizeId === variant.sizeId
            );

            if (exists) {
                toast.error("Variant for this size already exists");
                return;
            }

            const newVariant = {
                ...variant,
                id: null,
                tempId: crypto.randomUUID(),
                price: Number(variant.price),
                stockQuantity: Number(variant.stockQuantity),
                vendorDiscountPercentage: Number(variant.vendorDiscountPercentage || 0),
                marginPrice: Number(variant.marginPrice || 0),
                adminDiscountPercentage: Number(variant.adminDiscountPercentage || 0),
            };

            setProductData((prev) => ({
                ...prev,
                variants: [...(prev.variants || []), newVariant],
            }));

        } else {

            const updatedList = productData.variants.map((v) => {

                if (variant.id && v.id === variant.id) {
                    return { ...variant };
                }

                if (!variant.id && v.tempId === variant.tempId) {
                    return { ...variant };
                }

                return v;
            });

            setProductData((prev) => ({
                ...prev,
                variants: updatedList
            }));

            setIsEditing(false);
        }

        setVariant(emptyVariant);
    };

    // ================= EDIT =================
    const handleEdit = (item) => {

        setVariant({
            id: item.id || null,
            tempId: item.tempId || null,
            sizeId: item.sizeId,
            price: item.price,
            stockQuantity: item.stockQuantity,
            vendorDiscountPercentage: item.vendorDiscountPercentage,
            marginPrice: item.marginPrice,
            adminDiscountPercentage: item.adminDiscountPercentage,
        });

        setIsEditing(true);
    };

    // ================= REMOVE =================
    const handleRemove = (item) => {

        setProductData((prev) => ({
            ...prev,
            variants: prev.variants.filter((v) => {

                if (item.id) {
                    return v.id !== item.id;
                }

                return v.tempId !== item.tempId;
            })
        }));

        // If deleting currently editing item
        if (
            (variant.id && variant.id === item.id) ||
            (variant.tempId && variant.tempId === item.tempId)
        ) {
            setVariant(emptyVariant);
            setIsEditing(false);
        }
    };

    // ================= SAVE STEP =================
    const handleSaveAndNext = () => {

        if (!productData.variants || productData.variants.length === 0) {
            toast.error("Please add at least one variant");
            return;
        }

        onNext();
    };

    return (
        <Paper sx={{ p: 4, borderRadius: 3 }}>

            <Grid container spacing={3}>

                <Grid item xs={12} sm={6} md={Boolean(showFields) ? 4 : 6}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Size</InputLabel>
                        <Select
                            name="sizeId"
                            value={variant.sizeId}
                            label="Size"
                            onChange={handleChange}
                        >
                            {size?.sizes?.response?.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={Boolean(showFields) ? 4 : 6}>
                    <TextField
                        label="Price"
                        name="price"
                        size="small"
                        value={variant.price}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={Boolean(showFields) ? 4 : 6}>
                    <TextField
                        label="Stock Quantity"
                        name="stockQuantity"
                        size="small"
                        value={variant.stockQuantity}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={Boolean(showFields) ? 4 : 6}>
                    <TextField
                        label="Vendor Discount (%)"
                        name="vendorDiscountPercentage"
                        size="small"
                        value={variant.vendorDiscountPercentage}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>

                {showFields &&
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            label="Margin Price"
                            name="marginPrice"
                            size="small"
                            value={variant.marginPrice}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>
                }

                {showFields &&
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            label="Admin Discount (%)"
                            name="adminDiscountPercentage"
                            size="small"
                            value={variant.adminDiscountPercentage}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>
                }

                <Grid item xs={12} display="flex" justifyContent="center">
                    <Button
                        variant="contained"
                        onClick={handleSaveVariant}
                        sx={{ borderRadius: 2 }}
                    >
                        {isEditing ? "Update Variant" : "Add Variant"}
                    </Button>
                    {isEditing && (
                        <Button
                            variant="contained"
                            onClick={() => {
                                setVariant(emptyVariant);
                                setIsEditing(false);
                            }}
                            sx={{ borderRadius: 2, marginLeft: 3 }}
                        >
                            Cancle
                        </Button>
                    )}
                </Grid>

            </Grid>

            {/* ===== Variant List ===== */}
            <Grid container spacing={2} mt={4}>
                {(productData.variants || []).map((v) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={v.id ? `db-${v.id}` : `temp-${v.tempId}`}
                    >
                        <Card sx={{ position: "relative", borderRadius: 3 }}>
                            <CardContent>

                                <Typography fontWeight={600}>
                                    Size: {
                                        size?.sizes?.response?.find(
                                            s => s.id === v.sizeId
                                        )?.name
                                    }
                                </Typography>

                                <Typography variant="body2">Price: ₹ {v.price}</Typography>
                                <Typography variant="body2">Stock: {v.stockQuantity}</Typography>

                                {v.vendorDiscountPercentage && (
                                    <Typography variant="body2">
                                        Vendor Discount: {v.vendorDiscountPercentage}%
                                    </Typography>
                                )}
                                {showFields && (
                                    <>
                                        {v.marginPrice && Boolean(showFields) && (
                                            <Typography variant="body2">
                                                Margin: ₹{v.marginPrice}
                                            </Typography>
                                        )}

                                        {v.adminDiscountPercentage && Boolean(showFields) && (
                                            <Typography variant="body2">
                                                Admin Discount: {v.adminDiscountPercentage}%
                                            </Typography>
                                        )}
                                    </>
                                )}


                            </CardContent>

                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{ position: "absolute", top: 6, right: 6 }}
                            >
                                <IconButton size="small" onClick={() => handleEdit(v)}>
                                    <Edit fontSize="small" />
                                </IconButton>

                                <IconButton size="small" onClick={() => handleRemove(v)}>
                                    <Close fontSize="small" />
                                </IconButton>
                            </Stack>

                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Stack direction="row" justifyContent="flex-end" spacing={2} mt={4}>
                <Button variant="outlined" onClick={onBack}>
                    Back
                </Button>

                <Button variant="contained" onClick={handleSaveAndNext}>
                    Save & Continue
                </Button>
            </Stack>

        </Paper>
    );
};

export default VariantTabContent;